import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/wholesale-recepts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getInvoice = customer_id => {
  return httpClient
    .get(`/api/v1/wholesale-recepts/invoices/${customer_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getCustomer = (Options = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const reprint = id => {
  return httpClient
    .get(`/api/v1/wholesale-recepts/${id}/prints`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const bankProfile = () => {
  return httpClient
    .get('/api/v1/wholesale-recepts/bank-profiles')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .post(`/api/v1/wholesale-recepts/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const confirm = data => {
  return httpClient
    .post('/api/v1/wholesale-recepts/confirm', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const paymentMethod = (Option = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts/payment-methods', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExel = (Options = {}) => {
  return httpClient
    .post('/api/v1/wholesale-recepts/export-excels', Options, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/wholesale-recepts/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  store,
  getInvoice,
  reprint,
  bankProfile,
  destroy,
  confirm,
  paymentMethod,
  exportExel,
  getCustomer,
  formViewModel
}
